import * as Yup from 'yup';

// Esquema de validación para la tabla Clausurado
export const clausuradoValidationSchema = Yup.object().shape({
    fecha: Yup.date()
            .required('La fecha de cierre es obligatoria')
            .typeError('Debe ser una fecha válida'),
});

export const validateClausuradoForm = async (formData) => {
    try {
        await clausuradoValidationSchema.validate(formData, { abortEarly: false });
        return {}; // No hay errores
    } catch (error) {
        const errors = {};
        if (error.inner) {
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
        }
        return errors; // Devuelve los errores de validación
    }
};
